import React from "react";
import { getTagFromId } from "./notes";
import styles from "./NoteTags.module.scss";

export default function NoteTags({ids}) {

  let elements = ids.map((id) => {
    let tag = getTagFromId(id);
    let style = {
      backgroundColor: tag.get("background", "#ffffff"),
      color: tag.get("color", "#000000"),
    }
    return (
      <div className={styles.tag} key={id} title={tag.get("id", id)} style={style}>
        {tag.get("name", id)}
      </div>
    );
  });

  return (
    <>
      {elements}
    </>
  )

}